import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { logger } from '../utils/logger';
import { HttpResponseError } from '../errors';
import { StyErrorMessagesService } from '../errors/error-messages.service';

const CODE_NOT_LOGIN = 1011;
const CODE_TEAM_EXPIRED = 1012;
const CODE_SUCCESS = 200;
const CODE_MUST_INIT_PASSWORD = 8013;

const SKIP_EXCLUDE_PATHS = ['signin', 'expired'];

@Injectable()
export class ApiInterceptor implements HttpInterceptor {
    constructor(
        // private errorMessagesService: StyErrorMessagesService
    ) {}

    private _navigateUrl(url) {
        const _isSkip = !!SKIP_EXCLUDE_PATHS.find(path => {
            return location.pathname.indexOf(path) > -1;
        });
        if (_isSkip) {
            location.href = url;
        }
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const started = Date.now();
        let ok: string;

        let secureReq = req;
        if (req.url.includes('/api')) {
            const newParams = req.params.append('t', new Date().getTime().toString());
            secureReq = req.clone({
                params: newParams
            });
        }
        return next.handle(secureReq).pipe(
            tap(
                // Succeeds when there is a response; ignore other events
                event => {
                    if (req.url.includes('/api')) {
                        const response = event as HttpResponse<any>;
                        ok = event instanceof HttpResponse ? 'succeeded' : '';
                        if (response.body) {
                            // NOT LOGIN
                            if (response.body.code === CODE_NOT_LOGIN) {
                                // æé¤æ¶æ¯feedçunread clear api
                                if (!response.url.includes('/messages/unread/clear')) {
                                    this._navigateUrl('/signin?returnUrl=' + location.pathname + location.search);
                                }
                            } else if (response.body.code === CODE_TEAM_EXPIRED) {
                                // Expired to expired page
                                this._navigateUrl('/expired');
                            } else if (response.body.code === CODE_MUST_INIT_PASSWORD) {
                                // é¦æ¬¡ç»å½ééç½®å¯ç 
                                this._navigateUrl('/init');
                            } else if (response.body.code !== CODE_SUCCESS) {
                                const error = new HttpResponseError(
                                    `url:${response.url}, response code is ${
                                        response.body.code
                                    }, message is: ${response.body && response.body.message}`,
                                    response.body.code,
                                    response.url,
                                    response.body
                                );
                                error.method = req.method;
                                // error.errorMessage = this.errorMessagesService.getErrorMessageByCode(
                                //     response.body.code
                                // );
                                throw error;
                            } else {
                                (event as any).body = response.body.data;
                            }
                        }
                    }
                },
                // Operation failed; error is an HttpErrorResponse
                error => {
                    error.method = req.method;
                    ok = 'failed';
                }
            ),
            finalize(() => {
                const elapsed = Date.now() - started;
                const msg = `${req.method} "${req.urlWithParams}" ${ok} in ${elapsed} ms.`;
                logger.info(msg);
            })
        );
    }
}
